module.exports = __webpack_public_path__ + "img/intro_sub_no.6bcc9e1d.svg";